<cito-doe-app-info [visible]="appInfoOpen()"></cito-doe-app-info>

<header class="layout-header flex flex flex-row justify-content-between align-items-center">
  <p-menubar data-testid="doe-menu-bar" [model]="menuItems()">
    <ng-template #start>
      <div class="logo mr-3">
        <img alt="Logo" [src]="logoPath" />
      </div>
    </ng-template>
    <ng-template #item let-item let-root="root">
      <!-- Items with routerLink (navigation) -->
      @if (item.routerLink) {
        <a
          [routerLink]="item.routerLink"
          routerLinkActive="p-menubar-item-link-active"
          [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
          [attr.data-testid]="item.id"
          class="p-menubar-item-link">
          @if (item.icon) {
            <span [class]="'p-menubar-item-icon ' + item.icon"></span>
          }
          <span class="p-menubar-item-label">{{ item.label }}</span>
        </a>
      } @else {
        <!-- Items without routerLink (commands, parent items) -->
        <a
          [attr.data-testid]="item.id"
          class="p-menubar-item-link"
          (click)="item.command && item.command({ item: item })">
          @if (item.icon) {
            <span [class]="'p-menubar-item-icon ' + item.icon"></span>
          }
          <span class="p-menubar-item-label">{{ item.label }}</span>
          @if (item.items && root) {
            <i class="p-menubar-submenu-icon pi pi-angle-down"></i>
          }
          @if (item.items && !root) {
            <i class="p-menubar-submenu-icon pi pi-angle-right"></i>
          }
        </a>
      }
    </ng-template>
  </p-menubar>

  <div class="flex flex-row justify-content-end">
    <cito-doe-user-options styleClass="header"></cito-doe-user-options>

    <div data-testid="onscreen-info-btn" class="onscreen-info-btn mr-3 ml-1">
      <button type="button" pButton iconOnly
        (click)="toggleOnScreenInfo()"
        [attr.aria-label]="'APP_INFO.BUTTONS.OPEN_ON_SCREEN_INFO.ARIA_LABEL' | translate"
        class="p-button-rounded p-button-text p-button-secondary">
        <i class="pi pi-question-circle"></i>
      </button>
    </div>
  </div>
</header>

<main class="p-component doe-layout-content">
  @if (infoOnScreenOpen()) {
    <cito-doe-on-screen-info></cito-doe-on-screen-info>
  }
  <div class="doe-layout-body">
    <router-outlet></router-outlet>
  </div>
</main>
